/**
 * ObstructionList - List of obstructions with delete functionality
 *
 * Displays numbered obstruction items with individual delete buttons.
 */

import React from 'react';

interface ObstructionListProps {
  count: number;
  onDelete: (index: number) => void;
}

export function ObstructionList({ count, onDelete }: ObstructionListProps) {
  if (count === 0) return null;

  return (
    <div className="pt-2 border-t border-red-200 space-y-1 max-h-32 overflow-y-auto">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="flex items-center justify-between p-2 bg-white rounded border border-red-200 text-xs"
        >
          <span className="font-semibold">Obstruction {index + 1}</span>
          <button
            onClick={() => onDelete(index)}
            className="text-red-500 hover:text-red-700"
          >
            Delete
          </button>
        </div>
      ))}
    </div>
  );
}

export default ObstructionList;
